import { render, staticRenderFns } from "./RecruiterCompanyName.vue?vue&type=template&id=1c3c6c26&scoped=true"
import script from "./RecruiterCompanyName.vue?vue&type=script&lang=ts"
export * from "./RecruiterCompanyName.vue?vue&type=script&lang=ts"
import style0 from "./RecruiterCompanyName.vue?vue&type=style&index=0&id=1c3c6c26&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3c6c26",
  null
  
)

export default component.exports